import Picture from '../views/Cloud/Picture';
import Video from '../views/Cloud/Video';
import Audio from '../views/Cloud/Audio';

let Cloud = [
  {
    path: 'Picture',
    name: '图片库',
    component: Picture
  },
  {
    path: 'Video',
    name: '多媒体库',
    component: Video
  },
  {
    path: 'Audio',
    name: '音频库',
    component: Audio
  }
];

export default Cloud;
